import React from 'react';
import { List } from '@beisen/chaos-ui';

export default class RelateViewSelector extends React.Component {
    constructor(props) {
        super(props);
        this.handleTouchTap = this.handleTouchTap.bind(this);
    }

    handleTouchTap(event, relateViewObj) {
        event.preventDefault();
        event.persist();
        setTimeout(function() {
           this.props.onTouchTap && this.props.onTouchTap(relateViewObj, event);
        }.bind(this),0);
    }

    render() {
        let relateData = this.props.relateViews.map(item => {
            item.title = item.cmp_data.title;
            item.icon = item.cmp_data.titleIcon;
            return item;
        });
        return <List cls='relative-container' type='simple' datas={relateData} onTouchTap={this.handleTouchTap} />;
    }
}



// WEBPACK FOOTER //
// ./src/components/DetailPage/RelateViewSelector.js